import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PacienteDetalheComponent } from './paciente-detalhe/paciente-detalhe.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogAllModule } from '@syncfusion/ej2-angular-popups';
import { TextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { DatePickerAllModule, DateTimePickerAllModule } from '@syncfusion/ej2-angular-calendars';
import { LightInfoModule } from '../libs/light-info/light-info.module';
import { TabAllModule } from '@syncfusion/ej2-angular-navigations';
import { PanelModule } from '../libs/panel/panel.module';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { PacienteDoencaListaComponent } from './paciente-doenca-lista/paciente-doenca-lista.component';
import { PacienteAgenteListaComponent } from './paciente-agente-lista/paciente-agente-lista.component';
import { PacientePeriodicidadeListaComponent } from './paciente-periodicidade-lista/paciente-periodicidade-lista.component';
import { PacienteLotacaoListaComponent } from './paciente-lotacao-lista/paciente-lotacao-lista.component';
import { CheckBoxAllModule } from '@syncfusion/ej2-angular-buttons';
import { EditButtonModule } from '../libs/edit-button/edit-button.module';
import { PesquisaModule } from '../pesquisa/pesquisa.module';
import { PeriodicidadeModule } from '../periodicidade/periodicidade.module';
import { PacienteHistoriaListaComponent } from './paciente-historia-lista/paciente-historia-lista.component';
import { HistoriaClinicaModule } from '../historia-clinica/historia-clinica.module';



@NgModule({
  declarations: [
    PacienteDetalheComponent,
    PacienteDoencaListaComponent,
    PacienteAgenteListaComponent,
    PacientePeriodicidadeListaComponent,
    PacienteLotacaoListaComponent,
    PacienteHistoriaListaComponent
  ],
  imports: [
    CommonModule,
    DialogAllModule,
    ReactiveFormsModule,
    TextBoxAllModule,
    PanelModule,
    GridAllModule,
    CheckBoxAllModule,
    DatePickerAllModule,
    PesquisaModule,
    DateTimePickerAllModule,
    EditButtonModule,
    LightInfoModule,
    HistoriaClinicaModule,
    PeriodicidadeModule,
    TabAllModule
  ],
  exports: [
    PacienteDetalheComponent
  ]
})
export class PacienteModule { }
